module.exports = __webpack_public_path__ + "prod/1.42.2/img/msg4.3f2ee16c.png";